<template>
<div :class="$style.container">
    <profile v-if="isLoggedIn" />
    <a
        v-else
        :class="$style.login"
        :href="login">{{ $t("login") }}</a>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import Profile from "@/components/layouts/header/Profile.vue";
import { getLoginURL } from "@/data/links";

export default {
    components: { Profile },
    data: () => ({ login: getLoginURL() }),
    computed: {
        ...mapGetters(["isLoggedIn"])
    }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/mixins" as m;
@use "@material/typography/typography";
.container {
    min-height: 60px;
    border-bottom: 1px solid #dde2e580;
    display: flex;
    align-items: center;
    padding-left: 30px;
    .login {
        padding: 10px 20px;
        font-size: typography.px-to-rem(14px);
        border-radius: 3px;
        color: #000;
        border: solid 1px #eaeaea;
        background: none;
    }
    svg {
        color: #666666;
    }
    button {
        padding: 0;
        justify-content: flex-end;
    }
}
</style>
